module.exports = __webpack_public_path__ + "img/game3.84cd83f3.png";